import type { FC } from "react";

import { t } from "i18n/i18n";
import { Menu, MenuDivider, MenuItem } from "mds/components/Menu";
import { SquareButton, type SquareButtonProps } from "mds/components/buttons/SquareButton";
import { ChevronDownIcon } from "mds/icons";

interface LateSubmissionIntervalDropdownProps {
  value: number;
  className?: string;
  onChange: (value: number) => void;
  disabled?: boolean;
  size?: SquareButtonProps<"button">["size"];
  portal?: boolean;
}

export const LateSubmissionIntervalDropdown: FC<LateSubmissionIntervalDropdownProps> = ({
  value,
  onChange,
  className,
  disabled = false,
  size = "xs",
  portal,
}) => {
  const menuProps = portal !== undefined ? { portal } : {};
  return (
    <Menu
      {...menuProps}
      menuButton={
        <SquareButton className={className} disabled={disabled} kind="tertiary" size={size}>
          {value === Infinity ? t("timedelta.indefinite") : t("timedelta.days", { count: value })}
          <ChevronDownIcon />
        </SquareButton>
      }
    >
      <MenuItem checked={value === Infinity} onClick={() => onChange(Infinity)}>
        {t("timedelta.indefinite")}
      </MenuItem>

      <MenuDivider />
      {[1, 2, 3, 4, 5, 6, 7].map((i) => (
        <MenuItem checked={value === i} key={i} onClick={() => onChange(i)}>
          {t("timedelta.days", { count: i })}
        </MenuItem>
      ))}
    </Menu>
  );
};
